<template>
  <div class="all">
    <div class="header">
      <header>
        <div class="header-left">中国首家中小企业合规治理平台</div>
        <div class="header-right">
          <a href="https://admin.p2ipo.com/admin/index/login.html" target="_blank">登录</a>
        </div>
      </header>
    </div>
  </div>
</template>
<script>
export default {
  name: "headersP"
};
</script>
<style scoped>
@import './HeadersP.scss';
</style>





// WEBPACK FOOTER //
// src/components/pc/common/headers/HeadersP.vue